import { render, staticRenderFns } from "./BtnJustificativaDespViagem.vue?vue&type=template&id=36f562e4"
import script from "./BtnJustificativaDespViagem.vue?vue&type=script&lang=js"
export * from "./BtnJustificativaDespViagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports